var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessIconwith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5455",
    d: "M33.49 26.28a1 1 0 0 0-1.2-.7l-2.49.67a14.23 14.23 0 0 0 2.4-6.75a14.48 14.48 0 0 0-4.83-12.15a1 1 0 0 0-1.37.09a1 1 0 0 0 .09 1.41a12.45 12.45 0 0 1 4.16 10.46a12.19 12.19 0 0 1-2 5.74L28 22.54a1 1 0 1 0-1.95.16l.5 6.44l6.25-1.66a1 1 0 0 0 .69-1.2Z",
    className: "clr-i-outline clr-i-outline-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5455",
    d: "M4.31 17.08a1.06 1.06 0 0 0 .44.16a1 1 0 0 0 1.12-.85A12.21 12.21 0 0 1 18.69 5.84l-2.24 1.53a1 1 0 0 0 .47 1.79a1 1 0 0 0 .64-.16l5.33-3.66L18.33.76a1 1 0 1 0-1.39 1.38l1.7 1.7A14.2 14.2 0 0 0 3.89 16.12a1 1 0 0 0 .42.96Z",
    className: "clr-i-outline clr-i-outline-path-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5455",
    d: "M21.73 29.93a12 12 0 0 1-4.84.51a12.3 12.3 0 0 1-9.57-6.3l2.49.93a1 1 0 0 0 .69-1.84l-4.59-1.7L4.44 21l-1.11 6.35a1 1 0 0 0 .79 1.13h.17a1 1 0 0 0 1-.81l.42-2.4a14.3 14.3 0 0 0 11 7.14a13.91 13.91 0 0 0 5.63-.6a1 1 0 0 0-.6-1.9Z",
    className: "clr-i-outline clr-i-outline-path-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5455",
    d: "M22 13h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm-1 8h-6v-6h6Z",
    className: "clr-i-outline clr-i-outline-path-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIconwith);
export default __webpack_public_path__ + "static/media/process-iconwith.fbf2edac046017df1b83bb49124c95ba.svg";
export { ForwardRef as ReactComponent };